import { styled } from '@mui/system';

// simple utility component to override repetitive SectionContainer centering
export default styled('div')({ width: '100%' });
